module.exports = __webpack_public_path__ + "img/机构统计.040f6a0b.svg";